// extracted by mini-css-extract-plugin
module.exports = {"root":"HoverableIconBtn_root__1075J","text":"HoverableIconBtn_text__1eOL2","spinAround":"HoverableIconBtn_spinAround__3nxlO"};